import checkout from "./form3";

const {
  formField3: {
    taxAlternatePayerName,
    taxAlternatePayerId
  },
} = checkout;

const initialValues3 = {
  [taxAlternatePayerName.name]: "",
  [taxAlternatePayerId.name]: "",
};

export default initialValues3;
